export default __webpack_public_path__ + "static/media/lifeplantop1.abf4ba6a.png";